import { CommonModule } from '@angular/common';
import { Component, inject, input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../../../authentication/authentication.service';

@Component({
    selector: 'mce-navigation-item',
    imports: [CommonModule, MatIconModule, MatButtonModule],
    templateUrl: './navigation-item.component.html',
})
export class NavigationItemComponent {

  router = inject(Router);
  authenticationService = inject(AuthenticationService);

  routePath = input<string>();
  externalPath = input<string>();
  icon = input<string>();
  text = input<string>();

  disabled = () => this.router.url === this.routePath();


  onClick() {
    this.routePath()
      ? this.router.navigate([this.routePath()])
      : window.open(this.externalPath(), '_blank', 'noopener,noreferrer'); 
  }

}
